import { Link } from "react-router-dom";
import { usePageT } from "./i18n/LanguageContext";
import LanguageSwitcher from "./components/LanguageSwitcher";

const LOGO_URL = "https://nautiqo.cloud/logo-nautiqo.png";
const heading = { fontFamily: "'Cabinet Grotesk', 'Outfit', sans-serif" };

const translations = {
  it: {
    backHome: "Torna alla home",
    pageTitle: "Eliminazione account",
    pageSubtitle: "Come richiedere la cancellazione del tuo account Nautiqo",
    howToTitle: "Come richiedere l'eliminazione",
    howToIntro: "Se desideri eliminare il tuo account Nautiqo e tutti i dati ad esso associati, puoi farlo in due modi:",
    fromAppTitle: "Dall'app",
    fromAppStep1: "Apri l'app Nautiqo",
    fromAppStep2a: "Vai su",
    fromAppStep2b: "Impostazioni",
    fromAppStep3a: "Seleziona",
    fromAppStep3b: "Elimina account",
    fromAppStep4: "Conferma la richiesta",
    viaEmailTitle: "Via email",
    viaEmailText: "Invia una richiesta di eliminazione all'indirizzo:",
    viaEmailNote: "Includi l'indirizzo email associato al tuo account.",
    deletedTitle: "Dati che verranno eliminati",
    deletedIntro: "Una volta confermata l'eliminazione, i seguenti dati verranno cancellati in modo permanente:",
    deleted1: "Informazioni dell'account (nome, email, telefono, password)",
    deleted2: "Dati dell'azienda (nome attivita, configurazione)",
    deleted3: "Barche e relative configurazioni (prezzi, disponibilita, foto)",
    deleted4: "Prenotazioni e dati dei clienti",
    deleted5: "Calendario e impostazioni di disponibilita",
    deleted6: "Preferenze di notifica",
    deleted7: "Token di autenticazione e sessioni attive",
    deleted8: "Dati dello staff collegato all'account",
    retainedTitle: "Dati che potrebbero essere conservati",
    retainedIntro: "Alcuni dati potrebbero essere conservati per un periodo limitato anche dopo l'eliminazione dell'account, in conformita con obblighi di legge o per motivi legittimi:",
    colDataType: "Tipo di dato",
    colReason: "Motivo",
    colDuration: "Durata",
    row1Type: "Dati di fatturazione e transazioni",
    row1Reason: "Obblighi fiscali e contabili",
    row1Duration: "Fino a 10 anni",
    row2Type: "Log di sicurezza (IP, accessi)",
    row2Reason: "Prevenzione frodi e sicurezza",
    row2Duration: "Fino a 12 mesi",
    row3Type: "Dati aggregati e anonimi",
    row3Reason: "Analisi statistiche (non riconducibili all'utente)",
    row3Duration: "Indefinita",
    row4Type: "Comunicazioni con il supporto",
    row4Reason: "Risoluzione controversie",
    row4Duration: "Fino a 24 mesi",
    timingTitle: "Tempi di elaborazione",
    timingText1a: "La richiesta di eliminazione verra elaborata entro",
    timingText1b: "30 giorni",
    timingText1c: "dalla ricezione.",
    timingText2: "Durante questo periodo, l'account verra disattivato immediatamente e non sara piu accessibile. I dati verranno eliminati definitivamente al termine del periodo di elaborazione.",
    timingText3: "Riceverai una conferma via email al completamento della procedura di eliminazione.",
    importantTitle: "Nota importante",
    importantText1: "L'eliminazione dell'account e un'azione",
    importantIrreversible: "irreversibile",
    importantText2: ". Una volta completata, non sara possibile recuperare i dati eliminati. Ti consigliamo di esportare eventuali dati importanti prima di procedere con la richiesta.",
    contactsTitle: "Contatti",
    contactsIntro: "Per qualsiasi domanda relativa all'eliminazione dell'account:",
    contactsEmail: "Email:",
    contactsWebsite: "Sito web:",
    dataController: "Titolare del trattamento:",
    rightsReserved: "Tutti i diritti riservati.",
    privacyPolicy: "Privacy Policy",
  },
  en: {
    backHome: "Back to home",
    pageTitle: "Account deletion",
    pageSubtitle: "How to request the deletion of your Nautiqo account",
    howToTitle: "How to request deletion",
    howToIntro: "If you wish to delete your Nautiqo account and all data associated with it, you can do so in two ways:",
    fromAppTitle: "From the app",
    fromAppStep1: "Open the Nautiqo app",
    fromAppStep2a: "Go to",
    fromAppStep2b: "Settings",
    fromAppStep3a: "Select",
    fromAppStep3b: "Delete account",
    fromAppStep4: "Confirm the request",
    viaEmailTitle: "By email",
    viaEmailText: "Send a deletion request to the address:",
    viaEmailNote: "Include the email address associated with your account.",
    deletedTitle: "Data that will be deleted",
    deletedIntro: "Once deletion is confirmed, the following data will be permanently erased:",
    deleted1: "Account information (name, email, phone, password)",
    deleted2: "Company data (business name, configuration)",
    deleted3: "Boats and their configurations (prices, availability, photos)",
    deleted4: "Bookings and customer data",
    deleted5: "Calendar and availability settings",
    deleted6: "Notification preferences",
    deleted7: "Authentication tokens and active sessions",
    deleted8: "Data of staff linked to the account",
    retainedTitle: "Data that may be retained",
    retainedIntro: "Some data may be retained for a limited period even after the account is deleted, in compliance with legal obligations or for legitimate reasons:",
    colDataType: "Data type",
    colReason: "Reason",
    colDuration: "Duration",
    row1Type: "Billing and transaction data",
    row1Reason: "Tax and accounting obligations",
    row1Duration: "Up to 10 years",
    row2Type: "Security logs (IP, logins)",
    row2Reason: "Fraud prevention and security",
    row2Duration: "Up to 12 months",
    row3Type: "Aggregated and anonymous data",
    row3Reason: "Statistical analysis (not traceable to the user)",
    row3Duration: "Indefinite",
    row4Type: "Communications with support",
    row4Reason: "Dispute resolution",
    row4Duration: "Up to 24 months",
    timingTitle: "Processing times",
    timingText1a: "The deletion request will be processed within",
    timingText1b: "30 days",
    timingText1c: "of receipt.",
    timingText2: "During this period, the account will be deactivated immediately and will no longer be accessible. Data will be permanently deleted at the end of the processing period.",
    timingText3: "You will receive an email confirmation once the deletion procedure is complete.",
    importantTitle: "Important note",
    importantText1: "Account deletion is an",
    importantIrreversible: "irreversible",
    importantText2: " action. Once completed, it will not be possible to recover the deleted data. We recommend exporting any important data before proceeding with the request.",
    contactsTitle: "Contact",
    contactsIntro: "For any questions regarding account deletion:",
    contactsEmail: "Email:",
    contactsWebsite: "Website:",
    dataController: "Data controller:",
    rightsReserved: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
  },
  es: {
    backHome: "Volver al inicio",
    pageTitle: "Eliminación de cuenta",
    pageSubtitle: "Cómo solicitar la cancelación de tu cuenta Nautiqo",
    howToTitle: "Cómo solicitar la eliminación",
    howToIntro: "Si deseas eliminar tu cuenta Nautiqo y todos los datos asociados, puedes hacerlo de dos maneras:",
    fromAppTitle: "Desde la app",
    fromAppStep1: "Abre la app Nautiqo",
    fromAppStep2a: "Ve a",
    fromAppStep2b: "Ajustes",
    fromAppStep3a: "Selecciona",
    fromAppStep3b: "Eliminar cuenta",
    fromAppStep4: "Confirma la solicitud",
    viaEmailTitle: "Por email",
    viaEmailText: "Envía una solicitud de eliminación a la dirección:",
    viaEmailNote: "Incluye la dirección de email asociada a tu cuenta.",
    deletedTitle: "Datos que se eliminarán",
    deletedIntro: "Una vez confirmada la eliminación, los siguientes datos se borrarán de forma permanente:",
    deleted1: "Información de la cuenta (nombre, email, teléfono, contraseña)",
    deleted2: "Datos de la empresa (nombre del negocio, configuración)",
    deleted3: "Barcos y sus configuraciones (precios, disponibilidad, fotos)",
    deleted4: "Reservas y datos de los clientes",
    deleted5: "Calendario y ajustes de disponibilidad",
    deleted6: "Preferencias de notificación",
    deleted7: "Tokens de autenticación y sesiones activas",
    deleted8: "Datos del personal vinculado a la cuenta",
    retainedTitle: "Datos que podrían conservarse",
    retainedIntro: "Algunos datos podrían conservarse durante un período limitado incluso después de eliminar la cuenta, de conformidad con obligaciones legales o por motivos legítimos:",
    colDataType: "Tipo de dato",
    colReason: "Motivo",
    colDuration: "Duración",
    row1Type: "Datos de facturación y transacciones",
    row1Reason: "Obligaciones fiscales y contables",
    row1Duration: "Hasta 10 años",
    row2Type: "Registros de seguridad (IP, accesos)",
    row2Reason: "Prevención de fraude y seguridad",
    row2Duration: "Hasta 12 meses",
    row3Type: "Datos agregados y anónimos",
    row3Reason: "Análisis estadístico (no atribuibles al usuario)",
    row3Duration: "Indefinida",
    row4Type: "Comunicaciones con el soporte",
    row4Reason: "Resolución de disputas",
    row4Duration: "Hasta 24 meses",
    timingTitle: "Plazos de tramitación",
    timingText1a: "La solicitud de eliminación se tramitará en un plazo de",
    timingText1b: "30 días",
    timingText1c: "desde su recepción.",
    timingText2: "Durante este período, la cuenta se desactivará de inmediato y dejará de ser accesible. Los datos se eliminarán definitivamente al finalizar el período de tramitación.",
    timingText3: "Recibirás una confirmación por email al completarse el procedimiento de eliminación.",
    importantTitle: "Nota importante",
    importantText1: "La eliminación de la cuenta es una acción",
    importantIrreversible: "irreversible",
    importantText2: ". Una vez completada, no será posible recuperar los datos eliminados. Te recomendamos exportar cualquier dato importante antes de proceder con la solicitud.",
    contactsTitle: "Contacto",
    contactsIntro: "Para cualquier pregunta relativa a la eliminación de la cuenta:",
    contactsEmail: "Email:",
    contactsWebsite: "Sitio web:",
    dataController: "Responsable del tratamiento:",
    rightsReserved: "Todos los derechos reservados.",
    privacyPolicy: "Política de privacidad",
  },
  fr: {
    backHome: "Retour à l'accueil",
    pageTitle: "Suppression du compte",
    pageSubtitle: "Comment demander la suppression de votre compte Nautiqo",
    howToTitle: "Comment demander la suppression",
    howToIntro: "Si vous souhaitez supprimer votre compte Nautiqo et toutes les données associées, vous pouvez le faire de deux façons :",
    fromAppTitle: "Depuis l'application",
    fromAppStep1: "Ouvrez l'application Nautiqo",
    fromAppStep2a: "Allez dans",
    fromAppStep2b: "Paramètres",
    fromAppStep3a: "Sélectionnez",
    fromAppStep3b: "Supprimer le compte",
    fromAppStep4: "Confirmez la demande",
    viaEmailTitle: "Par e-mail",
    viaEmailText: "Envoyez une demande de suppression à l'adresse :",
    viaEmailNote: "Indiquez l'adresse e-mail associée à votre compte.",
    deletedTitle: "Données qui seront supprimées",
    deletedIntro: "Une fois la suppression confirmée, les données suivantes seront effacées définitivement :",
    deleted1: "Informations du compte (nom, e-mail, téléphone, mot de passe)",
    deleted2: "Données de l'entreprise (nom de l'activité, configuration)",
    deleted3: "Bateaux et leurs configurations (tarifs, disponibilité, photos)",
    deleted4: "Réservations et données des clients",
    deleted5: "Calendrier et paramètres de disponibilité",
    deleted6: "Préférences de notification",
    deleted7: "Jetons d'authentification et sessions actives",
    deleted8: "Données du personnel lié au compte",
    retainedTitle: "Données pouvant être conservées",
    retainedIntro: "Certaines données peuvent être conservées pendant une période limitée même après la suppression du compte, conformément aux obligations légales ou pour des motifs légitimes :",
    colDataType: "Type de donnée",
    colReason: "Motif",
    colDuration: "Durée",
    row1Type: "Données de facturation et de transactions",
    row1Reason: "Obligations fiscales et comptables",
    row1Duration: "Jusqu'à 10 ans",
    row2Type: "Journaux de sécurité (IP, connexions)",
    row2Reason: "Prévention de la fraude et sécurité",
    row2Duration: "Jusqu'à 12 mois",
    row3Type: "Données agrégées et anonymes",
    row3Reason: "Analyses statistiques (non attribuables à l'utilisateur)",
    row3Duration: "Indéfinie",
    row4Type: "Communications avec le support",
    row4Reason: "Résolution des litiges",
    row4Duration: "Jusqu'à 24 mois",
    timingTitle: "Délais de traitement",
    timingText1a: "La demande de suppression sera traitée dans un délai de",
    timingText1b: "30 jours",
    timingText1c: "à compter de sa réception.",
    timingText2: "Pendant cette période, le compte sera désactivé immédiatement et ne sera plus accessible. Les données seront définitivement supprimées à la fin de la période de traitement.",
    timingText3: "Vous recevrez une confirmation par e-mail une fois la procédure de suppression terminée.",
    importantTitle: "Note importante",
    importantText1: "La suppression du compte est une action",
    importantIrreversible: "irréversible",
    importantText2: ". Une fois effectuée, il ne sera pas possible de récupérer les données supprimées. Nous vous recommandons d'exporter toute donnée importante avant de procéder à la demande.",
    contactsTitle: "Contact",
    contactsIntro: "Pour toute question relative à la suppression du compte :",
    contactsEmail: "E-mail :",
    contactsWebsite: "Site web :",
    dataController: "Responsable du traitement :",
    rightsReserved: "Tous droits réservés.",
    privacyPolicy: "Politique de confidentialité",
  },
  de: {
    backHome: "Zurück zur Startseite",
    pageTitle: "Kontolöschung",
    pageSubtitle: "So beantragst du die Löschung deines Nautiqo-Kontos",
    howToTitle: "So beantragst du die Löschung",
    howToIntro: "Wenn du dein Nautiqo-Konto und alle damit verbundenen Daten löschen möchtest, kannst du dies auf zwei Wegen tun:",
    fromAppTitle: "Über die App",
    fromAppStep1: "Öffne die Nautiqo-App",
    fromAppStep2a: "Gehe zu",
    fromAppStep2b: "Einstellungen",
    fromAppStep3a: "Wähle",
    fromAppStep3b: "Konto löschen",
    fromAppStep4: "Bestätige die Anfrage",
    viaEmailTitle: "Per E-Mail",
    viaEmailText: "Sende eine Löschanfrage an die Adresse:",
    viaEmailNote: "Gib die mit deinem Konto verknüpfte E-Mail-Adresse an.",
    deletedTitle: "Daten, die gelöscht werden",
    deletedIntro: "Sobald die Löschung bestätigt ist, werden die folgenden Daten dauerhaft gelöscht:",
    deleted1: "Kontoinformationen (Name, E-Mail, Telefon, Passwort)",
    deleted2: "Unternehmensdaten (Firmenname, Konfiguration)",
    deleted3: "Boote und zugehörige Konfigurationen (Preise, Verfügbarkeit, Fotos)",
    deleted4: "Buchungen und Kundendaten",
    deleted5: "Kalender und Verfügbarkeitseinstellungen",
    deleted6: "Benachrichtigungseinstellungen",
    deleted7: "Authentifizierungstoken und aktive Sitzungen",
    deleted8: "Daten der mit dem Konto verbundenen Mitarbeiter",
    retainedTitle: "Daten, die aufbewahrt werden können",
    retainedIntro: "Einige Daten können auch nach der Löschung des Kontos für einen begrenzten Zeitraum aufbewahrt werden, im Einklang mit gesetzlichen Verpflichtungen oder aus berechtigten Gründen:",
    colDataType: "Datenart",
    colReason: "Grund",
    colDuration: "Dauer",
    row1Type: "Abrechnungs- und Transaktionsdaten",
    row1Reason: "Steuerliche und buchhalterische Pflichten",
    row1Duration: "Bis zu 10 Jahre",
    row2Type: "Sicherheitsprotokolle (IP, Anmeldungen)",
    row2Reason: "Betrugsprävention und Sicherheit",
    row2Duration: "Bis zu 12 Monate",
    row3Type: "Aggregierte und anonyme Daten",
    row3Reason: "Statistische Auswertung (nicht auf den Nutzer rückführbar)",
    row3Duration: "Unbefristet",
    row4Type: "Kommunikation mit dem Support",
    row4Reason: "Streitbeilegung",
    row4Duration: "Bis zu 24 Monate",
    timingTitle: "Bearbeitungszeiten",
    timingText1a: "Die Löschanfrage wird innerhalb von",
    timingText1b: "30 Tagen",
    timingText1c: "nach Eingang bearbeitet.",
    timingText2: "Während dieses Zeitraums wird das Konto sofort deaktiviert und ist nicht mehr zugänglich. Die Daten werden am Ende des Bearbeitungszeitraums endgültig gelöscht.",
    timingText3: "Nach Abschluss des Löschvorgangs erhältst du eine Bestätigung per E-Mail.",
    importantTitle: "Wichtiger Hinweis",
    importantText1: "Die Löschung des Kontos ist eine",
    importantIrreversible: "unwiderrufliche",
    importantText2: " Aktion. Nach Abschluss können die gelöschten Daten nicht wiederhergestellt werden. Wir empfehlen, alle wichtigen Daten zu exportieren, bevor du die Anfrage stellst.",
    contactsTitle: "Kontakt",
    contactsIntro: "Bei Fragen zur Löschung des Kontos:",
    contactsEmail: "E-Mail:",
    contactsWebsite: "Website:",
    dataController: "Verantwortlicher:",
    rightsReserved: "Alle Rechte vorbehalten.",
    privacyPolicy: "Datenschutzerklärung",
  },
};

const DeleteAccountPage = () => {
  const t = usePageT(translations);
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Manrope', sans-serif" }}>
      {/* Nav */}
      <nav className="border-b border-slate-200 bg-white sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/landing" className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-[22%] overflow-hidden flex-shrink-0"><img src={LOGO_URL} alt="Nautiqo" className="w-full h-full scale-[1.06]" /></div>
            <span className="font-bold text-xl text-slate-900 tracking-tight" style={heading}>Nautiqo</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/landing" className="text-slate-500 hover:text-slate-900 text-sm font-medium transition-colors">
              {t.backHome}
            </Link>
            <LanguageSwitcher variant="light" />
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-2" style={heading}>
          {t.pageTitle}
        </h1>
        <p className="text-slate-500 mb-10">{t.pageSubtitle}</p>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>{t.howToTitle}</h2>
            <p>{t.howToIntro}</p>

            <div className="grid sm:grid-cols-2 gap-4 mt-4">
              <div className="bg-slate-50 rounded-xl p-5 border border-slate-200">
                <h3 className="font-semibold text-slate-900 mb-2">{t.fromAppTitle}</h3>
                <ol className="list-decimal pl-5 space-y-1 text-sm">
                  <li>{t.fromAppStep1}</li>
                  <li>{t.fromAppStep2a} <strong>{t.fromAppStep2b}</strong></li>
                  <li>{t.fromAppStep3a} <strong>{t.fromAppStep3b}</strong></li>
                  <li>{t.fromAppStep4}</li>
                </ol>
              </div>
              <div className="bg-slate-50 rounded-xl p-5 border border-slate-200">
                <h3 className="font-semibold text-slate-900 mb-2">{t.viaEmailTitle}</h3>
                <p className="text-sm mb-2">{t.viaEmailText}</p>
                <a href="mailto:info@nautiqo.cloud" className="text-blue-600 hover:underline font-semibold">info@nautiqo.cloud</a>
                <p className="text-sm text-slate-500 mt-2">{t.viaEmailNote}</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>{t.deletedTitle}</h2>
            <p>{t.deletedIntro}</p>
            <ul className="list-disc pl-6 space-y-1 mt-3">
              <li>{t.deleted1}</li>
              <li>{t.deleted2}</li>
              <li>{t.deleted3}</li>
              <li>{t.deleted4}</li>
              <li>{t.deleted5}</li>
              <li>{t.deleted6}</li>
              <li>{t.deleted7}</li>
              <li>{t.deleted8}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>{t.retainedTitle}</h2>
            <p>
              {t.retainedIntro}
            </p>
            <div className="overflow-x-auto mt-3">
              <table className="w-full text-sm border border-slate-200 rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-slate-50">
                    <th className="text-left px-4 py-3 font-semibold text-slate-700">{t.colDataType}</th>
                    <th className="text-left px-4 py-3 font-semibold text-slate-700">{t.colReason}</th>
                    <th className="text-left px-4 py-3 font-semibold text-slate-700">{t.colDuration}</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  <tr>
                    <td className="px-4 py-3">{t.row1Type}</td>
                    <td className="px-4 py-3">{t.row1Reason}</td>
                    <td className="px-4 py-3">{t.row1Duration}</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3">{t.row2Type}</td>
                    <td className="px-4 py-3">{t.row2Reason}</td>
                    <td className="px-4 py-3">{t.row2Duration}</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3">{t.row3Type}</td>
                    <td className="px-4 py-3">{t.row3Reason}</td>
                    <td className="px-4 py-3">{t.row3Duration}</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3">{t.row4Type}</td>
                    <td className="px-4 py-3">{t.row4Reason}</td>
                    <td className="px-4 py-3">{t.row4Duration}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>{t.timingTitle}</h2>
            <p>
              {t.timingText1a} <strong>{t.timingText1b}</strong> {t.timingText1c}
            </p>
            <p className="mt-2">
              {t.timingText2}
            </p>
            <p className="mt-2">
              {t.timingText3}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>{t.importantTitle}</h2>
            <p>
              {t.importantText1} <strong>{t.importantIrreversible}</strong>{t.importantText2}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>{t.contactsTitle}</h2>
            <p>{t.contactsIntro}</p>
            <div className="bg-slate-50 rounded-xl p-4 mt-3">
              <p className="font-semibold text-slate-900">Nautiqo</p>
              <p>{t.contactsEmail} <a href="mailto:info@nautiqo.cloud" className="text-blue-600 hover:underline">info@nautiqo.cloud</a></p>
              <p>{t.contactsWebsite} <a href="https://nautiqo.cloud" className="text-blue-600 hover:underline">nautiqo.cloud</a></p>
            </div>
          </section>

        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-slate-200 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 space-y-3 text-center text-sm text-slate-500">
          <p className="leading-relaxed">
            <span className="font-medium text-slate-700">{t.dataController}</span>{" "}
            Seawave S.a.s. di Laudicina Marco &amp; C. · P.IVA <span className="select-all">02855570814</span><br />
            {t.contactsEmail} <a href="mailto:info@nautiqo.cloud" className="hover:text-slate-900 select-all">info@nautiqo.cloud</a>
          </p>
          <div className="flex items-center justify-between">
            <p>&copy; {new Date().getFullYear()} Nautiqo. {t.rightsReserved}</p>
            <Link to="/privacy" className="hover:text-slate-900 transition-colors">{t.privacyPolicy}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DeleteAccountPage;
